import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../../_base/crud';
// State
import { AppState } from '../../../reducers';
import { selectSiteInStore, selectSitePageLoading, selectSiteShowInitWaitingMessage } from '../_selectors/site.selectors';

export class SiteDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectSitePageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectSiteShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectSiteInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
